import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useDeleteAccount from '../../../../hooks/dashboard/settings/useDeleteAccount';
import {
  ConfirmToDeleteAccountDataType,
  ConfirmToDeleteAccountInitialValues,
  ConfirmToDeleteAccountSchema,
} from '../../../../models/dashboard/settings/confirm-to-delete-account';
import { useAppSelector } from '../../../../redux/store';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { FormComponent } from '../../../FormCom/FormComponent';
import { HideableTextFormField } from '../../../FormCom/HideableTextFormField';
import { TranslatingContainerContext } from '../../../TranslatingContainer/TranslatingContainerProvider';
import { ModalContext } from '../../ModalContext';

const DeleteConfirmationForm = () => {
  const { setSliderIndexPos } = React.useContext(TranslatingContainerContext)!;
  const modalContext = useContext(ModalContext);
  const { deleteReason } = useAppSelector((state) => state.deleteAccount);
  const { deleteAccount, loading } = useDeleteAccount();

  const onSubmit = (values: ConfirmToDeleteAccountDataType) => {
    const deleteAccountData = {
      password: values.confirmPassword,
      reason: deleteReason?.reasonToDeleteAccount ?? '',
    };

    deleteAccount(deleteAccountData, () => {
      modalContext?.setShowSuccessComponent(true);
      modalContext?.setSuccessDescription(
        `Your account information is scheduled to be permanently deleted from our system in the next 30 days ${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString()}.`,
      );
      modalContext?.setSecondarySuccessDescription(
        <span>
          If you wish to reactivate your account before this date, please
          contact our support team at{' '}
          <a
            href='mailto:support@rateduct.com'
            style={{ textDecoration: 'underline', color: 'inherit' }}
          >
            support@rateduct.com
          </a>
          .
        </span>,
      );
    });
  };

  return (
    <FormComponent
      initialValues={ConfirmToDeleteAccountInitialValues}
      schema={ConfirmToDeleteAccountSchema}
      onSubmit={onSubmit}
    >
      <HideableTextFormField
        label='Password'
        name='confirmPassword'
        id='confirmPassword'
        type='password'
        placeholder='Enter your password'
      />

      <SubmitBtnArea>
        <FormSubmitButton
          className='clear'
          btnType='button'
          onClick={() => {
            setSliderIndexPos(-1);
          }}
        >
          Cancel
        </FormSubmitButton>
        <FormSubmitButton loading={loading} className='red'>
          Submit
        </FormSubmitButton>
      </SubmitBtnArea>
    </FormComponent>
  );
};

export default DeleteConfirmationForm;

const SubmitBtnArea = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;
